import React, { useState, useEffect } from "react";
import Layout from "../../../components/layout/Layout";
import { useTranslation } from "react-i18next";

// React Icons
import { RiErrorWarningLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

import { Link, useParams } from "react-router-dom";
import { blobURL } from "common/StringUtils";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { LOCALES } from "common/constants";
import { readCookie } from "common/FunctionUtils";

export default function AccountCreated() {
  const welcomeImage = `${blobURL}/welcomeImage.jpg`;
  const language = localStorage.getItem("i18nextLng");
  const { email } = useParams();
  const { t } = useTranslation();
  const isProduction = import.meta.env.VITE_NODE_ENV === "production";
  // TODO: Remove after testing production
  console.log('env...', import.meta.env.VITE_NODE_ENV, isProduction);

  const userdata = useSelector((s) => s?.auth?.userData?.response);
  const [toggleModal, settoggleModal] = useState(userdata?.isBelowEighteen);
  const [hasMarketingConsent, setHasMarketingConsent] = useState(false);

  useEffect(() => {
    const cookieValue = readCookie("_cc_cookieConsent");
    if (cookieValue) {
      try {
        const parsedCookie = JSON.parse(cookieValue);
        const consents = parsedCookie.consents || [];
        setHasMarketingConsent(consents.includes("marketing"));
      } catch (error) {
        console.error("Error parsing cookie:", error);
      }
    }
  }, []);

  return (
    <Layout
      className="d-flex sign-up-email align-items-center"
      hidefooter
      headerColor="secondary"
    >
      {hasMarketingConsent && isProduction && (
        <Helmet>
          <script type="text/javascript">
            {`
        if (typeof tdconv !== "undefined" && tdconv !== null) {
          tdconv('init', '2358708', {'element': 'iframe'});
          tdconv('track', 'sale', {'transactionId': '${email}', 'ordervalue': '0', 'currency': 'SEK', 'event': 437992});
        }
      `}
          </script>
        </Helmet>
      )}

      <div className="container">
        <div className="welcome-shadow-box">
          <img
            src={welcomeImage}
            alt="Welcome"
            className="welcome-image"
            loading="lazy"
          />
          <h2>
            <span>{t("Welcome to Invozio")}</span>
          </h2>
          <div className="ReactModal__Content">
            <div className="loyalty-info-modal">
              <div>
                <div className="difference-wrapper">
                  <div className="difference-col">
                    <p className="difference-title">
                      <span> {t("Thank you for creating your account. Please sign in to create your first invoice.")}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        centered
        show={toggleModal}
        onHide={() => settoggleModal(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body>
          <div
            style={{
              position: "absolute",
              right: "7px",
              fontSize: "22px",
              cursor: "pointer",
              top: 0,
              color: "#000000ad",
            }}
          >
            <RxCross2 onClick={() => settoggleModal(false)} />
          </div>

          <RiErrorWarningLine
            style={{
              fontSize: "60px",
              color: "#ff00008a",
              display: "block",
              margin: "0 auto",
            }}
          />
          <p className="text-center">
            {t(
              "As you are under 18, we require an email from your parent or guardian, providing consent, to be sent to"
            )}
            <strong className="ml-2 mr-2">
              <a href="mailto:support@invozio.com">support@invozio.com</a>
            </strong>
            {t(
              "in order to activate your account. For more information, please refer to our"
            )}
            <strong>
              <Link
                className="ml-1 mr-1"
                target="_blank"
                to={`${
                  language === LOCALES.EN_US
                    ? `/faq?lang=${LOCALES.EN_US}&id=under_18`
                    : `/faq?lang=${LOCALES.SV_SE}&id=under_18`
                }`}
                style={{ textDecoration: "underline" }}
              >
                {t("FAQ")}
              </Link>
            </strong>
            {t("section")}
          </p>
        </Modal.Body>
      </Modal>
    </Layout>
  );
}
